import Proptypes from "prop-types";
import "./button.scss";
import Images from "../images/images";
import icoPlus from "../../../images/ico-plus-white.svg"

function Button({
  type,
  onClick,
  name,
  primary,
  googleSignIn,
  children,
  icon,
  borderless,
  reverseIcon,
  noHover,
  addButton,
  disabled,
  ...otherButtonProps
}) {
  return (
    <button
      className={`
          button
          button-secondary
          ${primary ? "button--primary" : ""}
          ${googleSignIn ? "button--google" : ""}
          ${borderless ? "button-borderless" : ""}
          ${reverseIcon ? "button-reverseIcon" : ""}
          ${noHover ? "button-noHover" : ""}
          ${addButton ? "button-addButton" : ""}
        `}
      type={type}
      onClick={onClick}
      disabled={disabled}
      {...otherButtonProps}
    >
      {children}
      {icon != null && (
        <div className={"iconButton"}>
          <div className={"iconContainer"}>
            <img alt={name} src={icon} />
          </div>
          {name}
        </div>
      )}
      {icon == null && 
      <div className={"button-container"}>
        {addButton && <Images className={"button-add"} Imagen={icoPlus} /> }
        <span className={"button-text"}>{name}</span>
      </div>
      }
    </button>
  );
}

Button.defaultProps = {
  type: "button",
};
Button.propTypes = {
  type: Proptypes.string,
  onClick: Proptypes.func.isRequired,
  name: Proptypes.string,
  primary: Proptypes.bool,
  googleSignIn: Proptypes.bool,
  icon: Proptypes.string,
  borderless: Proptypes.bool,
  addButton: Proptypes.bool,
};

export default Button;
